import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import PageTitle from '../../../components/PageTitle/PageTitle';
import CardGrid from '../../../components/Layout2/CardGrid/CardGrid';
import { ASSETS_BASE_URL } from '../../../config';
import { useTranslation } from 'react-i18next';

const DigitalSolutions = () => {
    const { t } = useTranslation();

    const digitalData = useMemo(() => ([
        { title: t('TITLES.PREVENTIVE_MAINTENANCE_DASHBOARD'), img: `${ASSETS_BASE_URL}/ImageBoxes/preventive_dashboard.jpg`, href: '/service/digital-solutions/preventive-dashboard' },
        { title: t('TITLES.SUSTAINABLE_OVEN_SERVICE_DASHBOARD'), img: `${ASSETS_BASE_URL}/ImageBoxes/sustainable_dashboard.jpg`, href: '/service/digital-solutions/sustainable-oven-service-dashboard' },
        { title: t('TITLES.PREDICTIVE_MAINTENANCE_DASHBOARD'), img: `${ASSETS_BASE_URL}/ImageBoxes/predictive_dashboard.jpg`, href: '/service/digital-solutions/predictive-dashboard' },
        { title: t('TITLES.MACHINE_DASHBOARD'), img: `${ASSETS_BASE_URL}/ImageBoxes/machine_dashboard.jpg`, href: '/service/digital-solutions/machine-dashboard' },
    ]), [t]);

    return (
        <Box sx={{ p: 2, pt: 0, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <PageTitle title={t('LABELS.DIGITAL_SOLUTIONS')} />
            <CardGrid data={digitalData} />
        </Box>
    );
};

export default DigitalSolutions;
